import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ModalInner from './ModalInner';

class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
    this.handleCancelAction = this.handleCancelAction.bind(this);
    if (typeof window !== 'undefined') {
      this.modalRoot = document.getElementById('___gatsby');
      this.el = document.createElement('div');
    }
  }

  componentDidMount() {
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.el);
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show,
    });
  }

  componentWillUnmount() {
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.el);
    }
  }

  handleCancelAction() {
    this.setState({
      show: false,
    });
    this.props.onCancel();
  }

  render() {
    if (this.el) {
      return ReactDOM.createPortal(
        <ModalInner
          show={this.state.show}
          onCancel={this.handleCancelAction}
        >
          {this.props.children}
        </ModalInner>,
        this.el,
      );
    }
    return null;
  }
}

Modal.defaultProps = {
  selector: '#___gatsby',
  show: false,
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  selector: PropTypes.string,
  show: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/index.jsx